import React from 'react'

// material ui
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

import NavButtons from 'components/register/shared/NavButtons'

// shared components (registration and account)
import Camper from 'components/shared/Cart/Form/Camper'
import Summary from 'components/shared/Cart/Form/Summary'

// Financial aid components
import FinancialAidInfo from 'components/account/Plans/FinancialAidInfo'

// helpers
import { canSubmit } from 'lib/cart/decorators/cartForm'

const Form = props => {
  const {
    pathname, // via withPathname
    account, // via withQuery
    sessions, // via withQuery
    session, // via withQuery
    mutationLoading, // via withMutation
    cartForm, // via redux state
    inputErrors, // via withFormResults
    onClickSave, // via withEventHandlers
    onToggleDate // via withEventHandlers
  } = props

  const eligibleCampers = camper =>
    camper.confirmed || (camper.plans && camper.plans.length > 0)

  return (
    <>
      {account.campers.filter(eligibleCampers).map(camper => (
        <Camper
          key={camper.id}
          camper={camper}
          account={account}
          sessions={sessions}
          cartForm={cartForm}
          inputErrors={inputErrors}
          onToggleDate={onToggleDate}
        />
      ))}

      <FinancialAidInfo account={account} sessions={sessions} />

      {cartForm && (
        <Box mb={4}>
          <Typography my={4} variant='h3' align='center'>
            Shopping Cart
          </Typography>
          <Summary account={account} sessions={sessions} cartForm={cartForm} />

          <Box my={2}>
            <NavButtons
              account={account}
              pathname={pathname}
              mutationLoading={mutationLoading}
              disableContinue={!canSubmit({ account, cartForm, sessions })}
              onClickContinue={onClickSave}
            />
          </Box>
        </Box>
      )}
    </>
  )
}

export default Form
